import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { IncomeRoutes } from '../../routes/income';
import { PersonalDetailsRoutes } from '../../routes/personal_details';
import { SpouseIncomeRoutes } from '../../routes/spouseIncome';
import { TaxesDeductionsRoutes } from '../../routes/taxesDeductions';
import { BaseQuestionnaireRoute } from '../../routes/slice';
import { NonUsFinancialAccountsRoutes } from '../../routes/nonUsFinancialAccounts';
import {
  expandSubTab,
  selectQuestionnaireRoutes,
  toggleSubTab,
} from '../../routes/slice';
import FirstLevelSubTabs from './FirstLevelSubTabs';
import {
  WhereILiveRoutes,
  WhereILiveSubRoutes,
} from '../../routes/personal_details/where_i_live';
import {
  TheBasicsRoutes,
  TheBasicsSubRoutes,
} from '../../routes/personal_details/the_basics';

type SubRoute = BaseQuestionnaireRoute | any;

const AccordionLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const storeQuestionnaireRoutes = useSelector(selectQuestionnaireRoutes);

  const onToggle = (path: string) => {
    dispatch(toggleSubTab(path));
  };

  useEffect(() => {
    const pathLength = location?.pathname?.split('/').slice(4, -1).length;
    const path = location?.pathname?.split('/').slice(4, -1).join('.');
    if (pathLength && pathLength > 1 && path) {
      dispatch(expandSubTab(path));
    }
  }, [location]);

  const isFirstLevelSubTabsOf = (mainTabPath: string) =>
    location?.pathname?.split('/').slice(-3).includes(mainTabPath);

  return (
    <>
      {Object.values(storeQuestionnaireRoutes.routes).map((route) => {
        const { path: mainTabPath, title, isValid, ...rest } = route;
        const subRoutes: SubRoute = rest;

        if (!isFirstLevelSubTabsOf(mainTabPath)) return <></>;
        return (
          <FirstLevelSubTabs mainTabPath={mainTabPath} subRoutes={subRoutes} />
        );
      })}
    </>
  );
};

export default AccordionLayout;
